module.exports = __webpack_public_path__ + "static/media/lock-orange.8a65a075.svg";